<template>
<layout-content>
  <template #toolbar>
    <el-radio-group v-model="conditions.status" size="small" @change="onStatusConditionChanged">
      <el-radio-button :label="true">启用</el-radio-button>
      <el-radio-button :label="false">停用</el-radio-button>
    </el-radio-group>

    <el-select
      v-model="conditions.groupId"
      placeholder="分组查询"
      size="small"
    >
      <el-option
        v-for="item in filterFactorGroups"
        :key="item.id"
        :value="item.id"
        :label="item.name"
      />
    </el-select>
  </template>
  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="currentFactors"
        height="100%"
        border
        stripe
        lazy
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table no-inner-border"
        style="width: 100%"
        @selection-change="onSelectionChange"
        @row-click="onOpenEditor"
      >
        <el-table-column label="序号" width="70">
          <template slot-scope="{$index}">{{$index + 1}}</template>
        </el-table-column>

        <el-table-column prop="displayName" label="因子名称" />
        <el-table-column label="分组">
          <template slot-scope="{row}">{{(factorGroupMap[row.groupId] || {}).name}}</template>
        </el-table-column>
        <el-table-column prop="cas" label="cas" />
        <el-table-column prop="molecular" label="分子量" />
        <el-table-column prop="stdUnit" label="标准单位" />
        <el-table-column label="修正范围">
          <template slot-scope="{row}">{{Number.isFinite(row.amendLowRange) ? row.amendLowRange : '--'}} ~ {{Number.isFinite(row.amendHighRange) ? row.amendHighRange : '--'}}</template>
        </el-table-column>
        <el-table-column label="超标范围">
          <template slot-scope="{row}">{{Number.isFinite(row.limitLow) ? row.limitLow : '--'}} ~ {{Number.isFinite(row.limitHigh) ? row.limitHigh : '--'}}</template>
        </el-table-column>
        <el-table-column prop="amendValue" label="修正值" />
        <el-table-column label="是否启用" align="center">
          <template slot-scope="{row}">
            <my-switch
              v-model="row.status"
              @click.native.stop
              @change="onChangeStatus(row, ...arguments)"
            />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="{row}">
            <div class="table-operator-wrapper">
            <span
              class="table-operator-btn related-factor-settings-btn"
              @click.stop="onOpenRelatedFactorEditor(row)"
            >
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
            </span>
              <span
                class="table-operator-btn ratio-factor-settings-btn"
                @click.stop="onOpenRatioFactorEditor(row)"
              >
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
            </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
      :group-list="filterFactorGroups"
      @save="getList"
      @close="onCancelHighlightTableRow"
    />

    <related-factor-editor
      ref="relatedFactorEditor"
      :current-factor="currentFactor"
    />

    <ratio-factor-editor
      ref="ratioFactorEditor"
      :current-factor="currentFactor"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../../BaseListEditor'
import Editor from './Editor'
import LayoutContent from '../../../../components/Layout/Content'
import RelatedFactorEditor from './RelatedFactorEditor'
import RatioFactorEditor from './RatioFactorEditor'
import DataWrapper from '../../../../components/Data/DataWrapper'

export default {
  name: 'SystemSettingsFactor',
  routeInfo: {
    label: '因子管理',
    icon: 'fa fa-dot-circle-o',
    curdInfo: {
      api: 'Factor',
      id: 'id',
      name: 'name',
      editName: '因子'
    }
  },
  extends: BaseListEditor,
  components: {DataWrapper, RelatedFactorEditor, RatioFactorEditor, LayoutContent, Editor},
  data () {
    return {
      conditions: {
        status: true,
        groupId: ''
      },
      currentFactor: {}
    }
  },
  computed: {
    filterList () {
      let {status} = this.conditions
      return this.list.filter(factor => factor.status === status)
    },
    factorGroupIdTree () {
      return this.filterList.reduce((map, factor) => {
        let {groupId} = factor
        let factors = map[groupId]

        if (!Array.isArray(factors)) {
          factors = map[groupId] = []
        }

        factors.push(factor)

        return map
      }, {})
    },
    filterFactorGroups () {
      let {factorGroupIdTree} = this
      return this.factorGroups.filter(factorGroup => Array.isArray(factorGroupIdTree[factorGroup.id]))
    },
    currentFactors () {
      return this.factorGroupIdTree[this.conditions.groupId] || []
    }
  },
  methods: {
    setFactorGroupId () {
      let {conditions, filterFactorGroups} = this
      let {groupId} = conditions

      if (!groupId || !filterFactorGroups.find(factorGroup => factorGroup.id === groupId)) {
        conditions.groupId = (filterFactorGroups[0] || {id: null}).id
      }
    },
    setList (list) {
      this.list = list
    },
    afterQuery () {
      this.setFactorGroupId()
    },
    onStatusConditionChanged () {
      // this.setFactorGroupId()
    },
    onOpenRelatedFactorEditor (row) {
      this.currentFactor = Object.freeze(JSON.parse(JSON.stringify(row)))
      this.$refs.relatedFactorEditor.open(row)
    },
    onOpenRatioFactorEditor (row) {
      this.currentFactor = Object.freeze(JSON.parse(JSON.stringify(row)))
      this.$refs.ratioFactorEditor.open(row)
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.related-factor-settings-btn {
  &:after {
    content: "相关因子"
  }
}
.ratio-factor-settings-btn {
  &:after {
    content: "比值因子"
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/04Factor/index.vue